module.exports = __webpack_public_path__ + "img/EVERCNBJXXX.37fa300f.png";